module.exports = __webpack_public_path__ + "static/media/Well-being-nutritionist.52a3fe40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/HamburgerIcons/Well-being-nutritionist.svg
// module id = 565
// module chunks = 1